/**
 * Provides functionality to create IFrames.
 */
export var ContentWindow;
(function (ContentWindow) {
    ContentWindow.create = (id, targetOrigin) => ({ id, targetOrigin });
})(ContentWindow || (ContentWindow = {}));
//# sourceMappingURL=ContentWindow.js.map